export const BAR_HEIGHT = 50;
export const BUTTON_SIZE = 32;
export const BUTTON_PROPS = {
  Button_minHeight_medium: BUTTON_SIZE,
  Button_paddingHorizontal_withIconMedium: "11px",
  Button_color_whiteNaked_disabled: "rgba(255, 255, 255, 0.8)"
};
export const getBarColor = props => props.theme.vstui.color.primary.getShade(7);
